import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { MessageBox, Message, Loading } from 'element-ui'
import { saveAs } from 'file-saver'
// 基本参数设置
axios.defaults.timeout = 120000
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.headers.post['Content-Type'] = 'application/json'

// http 请求拦截器
axios.interceptors.request.use(
  (config) => {
    var token = store.getters.token
    // var meta = router.history.current.meta
    // var permit = meta.permit ? meta.permit : ''
    if (token && token.accessToken) {
      config.headers.Authorization =
        (token.tokenHead && token.tokenHead.length > 0 ? token.tokenHead : 'Bearer') +
        ' ' +
        (token.accessToken ? token.accessToken : '')
    }
    // if (permit) config.headers.uspPermit = permit
    return config
  },
  (error) => {
    return Promise.error(error)
  }
)

async function errorFn(err) {
	console.log(123123,err);
  if (err.response && err.response.status) {
    var res = err.response.data
    const code = res?.code || err.response.status
    var message
    switch (code) {
      // 未登录 清除已登录状态
      case 401:
        message = res?.message || 'Login status has expired, please login again!'
        MessageBox.confirm(message, 'System prompt', {
          confirmButtonText: 'confirm',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {
          store.commit('SET_TOKEN', '')
          router.replace('/login')
        })
        break
      // token过期 使用refreshToken更新token后重新请求
      case 402:
        var token = store.getters.token
        if (token) {
          var { success, data } = await refreshToken(token)
          if (success) {
            store.commit('SET_TOKEN', data)
            message = res?.message || 'Network congestion, please try again later!'
            MessageBox.confirm(message, 'System prompt', {
              confirmButtonText: 'confirm',
              showCancelButton: false,
              type: 'error'
            }).then(() => { })
          } else {
            message = res?.message || 'Login status has expired, please login again!'
            MessageBox.confirm(message, 'System prompt', {
              confirmButtonText: 'confirm',
              showCancelButton: false,
              type: 'warning'
            }).then(() => {
              router.replace('/login')
            })
          }
        } else {
          message = res?.message || 'Login status has expired, please login again!'
          MessageBox.confirm(message, 'System prompt', {
            confirmButtonText: 'confirm',
            showCancelButton: false,
            type: 'warning'
          }).then(() => {
            router.replace('/login')
          })
        }
        break
      // 没有权限操作
      case 403:
        message = res?.message || 'You do not have permission to operate, please contact the administrator!'
        MessageBox.confirm(message, 'System prompt', {
          confirmButtonText: 'confirm',
          showCancelButton: false,
          type: 'error'
        }).then(() => {

        })
        break
      // 参数为空或类型错误
      case 415:
        message = res?.message || 'Parameter is empty or type wrong!'
        MessageBox.confirm(message, 'System prompt', {
          confirmButtonText: 'confirm',
          showCancelButton: false,
          type: 'error'
        }).then(() => { })
        break
      // 请求拦截
      case 429:
        message = res?.message || 'Your visit is too frequent, please try again later!'
        MessageBox.confirm(message, 'System prompt', {
          confirmButtonText: 'confirm',
          showCancelButton: false,
          type: 'error'
        }).then(() => { })
        break
      // 500错误
      case 500:
        message = res?.message || 'Server 500 error!'
        MessageBox.confirm(message, 'System prompt', {
          confirmButtonText: 'confirm',
          showCancelButton: false,
          type: 'error'
        }).then(() => { })
        break
      default:
        message = res?.message || 'Unknown error！'
        break
    }
  }
  return Promise.reject({ success: false, message: message })
}

// http 响应拦截器
axios.interceptors.response.use(
  (response) => {
	  if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
	    return response
	  }
    // 文件下载专用
    if (response.status === 201) return response
    var data = response.data
    // 根据返回的code值来做不同的处理(和后端约定)
    if (data.code === 200) {
      return data
    } else if (data.code === 0) {
      Message.error(data.msg)
    } else if (data.code == 102) {
		return data
	} else if (data.code == 4001) {
		return data
	}

    return errorFn({ response })

    // return Promise.reject({ response })
    // switch (data.code) {
    //   default:
    //     return data
    // }
  },
  async(err) => {
    return errorFn(err)
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .request(url, {
        params: params,
        method: 'get'
      })
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * 刷新Token
 * @param {参数} param
 */
function refreshToken(data) {
  return Post('/auth/RefreshToken', data)
}

// 验证是否为blob格式
async function blobValidate(data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}
let downloadLoadingInstance
// 通用下载方法
export async function downFilePost(url, params, config) {
  downloadLoadingInstance = Loading.service({ text: 'Please wait while downloading data', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
  console.log(url, params);
  return axios
    .post(url, params,{ responseType: 'blob',headers: { 'Authorization': 'Bearer ' + store.getters.token.accessToken }})
    .then(async (resp) => {
      const { data } = resp
      const isLogin = await blobValidate(data)
      if (isLogin) {
        var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        var contentDisposition = decodeURI(resp.headers['content-disposition'])
        var result = patt.exec(contentDisposition)
        var fileName = result[1]
        fileName = fileName.replace(/\"/g, '')

        const blob = new Blob([data],{ type: resp.headers['content-type'] })
        saveAs(blob, fileName)
      } else {
        const resText = await data.text()
        const rspObj = JSON.parse(resText)
        const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
        Message.error(errMsg)
      }
      downloadLoadingInstance.close()
    })
    .catch((r) => {
      Message.error('Error downloading file, please contact administrator!')
      downloadLoadingInstance.close()
    })
}
// 通用下载方法
export async function downFile(url, params, config) {
  downloadLoadingInstance = Loading.service({ text: 'Please wait while downloading data', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
  return axios
    .get(url, {
      params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
      ...config,
    })
    .then(async (resp) => {
      const { data } = resp

      const isLogin = await blobValidate(data)
      if (isLogin) {
        var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        var contentDisposition = decodeURI(resp.headers['content-disposition'])
        var result = patt.exec(contentDisposition)
        var fileName = result[1]
        fileName = fileName.replace(/\"/g, '')

        const blob = new Blob([data])
        saveAs(blob, fileName)
      } else {
        const resText = await data.text()
        const rspObj = JSON.parse(resText)
        const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
        Message.error(errMsg)
      }
      downloadLoadingInstance.close()
    })
    .catch((r) => {
      Message.error('Error downloading file, please contact administrator!')
      downloadLoadingInstance.close()
    })
}